import ReactDOM from "react-dom";
import DatepickerWithLabel from "../../../../common/interactive/DatepickerWithLabel";
import BodySimpleModalV3 from "../../../../common/modal/BodySimpleModalV3";
import { formatDateLocal } from "../../../../../lib/script";
import Button from "../../../../common/Button";
import { getFutureSurgicalAppointments } from "../../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { notificationActions } from "../../../../../store/notifications";
import Backdrop from "../../../../common/modal/Backdrop";
import Modal from "../../../../common/Modal";
import ModalInnerWrapper from "../../../../common/ModalInnerWrapper";
import PannelBody from "../../../../fragments/PannelBody";
import FutureAppointmentItem from "./FutureAppointmentItem";

export default function AppointmentScheduledDate({itemData, updateHandler, apiCase}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [futureSurgicalAppointments, setFutureSurgicalAppointments] = useState([])


    const getFutureSurgicalAppointmentsHandler = async () => {
        setLoading(true)
        try {
            const futureSurgicalAppointments = await getFutureSurgicalAppointments(userToken, activeCase.case.id)

            if (futureSurgicalAppointments && futureSurgicalAppointments.errorMessage) {
                dispatch(notificationActions.setError(futureSurgicalAppointments))
            } else {            
                setFutureSurgicalAppointments(futureSurgicalAppointments)
                setShowModal(true)
            }  
        } finally {
            setLoading(false)
        }
    }

    let message = <div>Surgery re-scheduled, initial date was: {formatDateLocal(itemData.step_7_initial_scheduled_date)}</div>

    let altMessage = <div>
        <p><strong>If you leave this field empty, the system will try to fill it automatically based on the appointment date:</strong></p>
        <ul>
        <li>It first looks for a surgery where the <strong>estimated surgical date matches the appointment date</strong> and <strong>no surgery date is set</strong> — this is a perfect match.</li>
        <li>If none is found, it looks for surgeries with an estimated date and <strong>no scheduled surgery date</strong>:
            <ul>
            <li>If one exists, it will auto-select it <strong>if the date is within 7 days</strong> of the appointment.</li>
            <li>If multiple exist, it picks the one <strong>closest to the appointment date</strong>, but only if it is within <strong>±2 days</strong>.</li>
            </ul>
        </li>
        </ul>
        <p><strong>Note:</strong> “Surgery date is empty” means the surgery is not yet linked to any appointment.</p>
    </div>

    return <div className="flex-container">
        <div style={{flex: 1}}>
            {itemData.step_7_initial_scheduled_date && 
                <BodySimpleModalV3 message={message}>
                    <DatepickerWithLabel disableDaysModal={true} label={'Scheduled Date'} action={updateHandler} defaultDate={itemData.step_7_scheduled_date} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_scheduled_date', type_id: itemData.id}}/>
                </BodySimpleModalV3>
            }
            {!itemData.step_7_initial_scheduled_date && 
                <BodySimpleModalV3 message={altMessage} fixedWidth={'300px'}>
                    <DatepickerWithLabel disableDaysModal={true} label={'Scheduled Date'} action={updateHandler} defaultDate={itemData.step_7_scheduled_date} identifier={{folder: 'surgeries', type: apiCase, field: 'step_7_scheduled_date', type_id: itemData.id}}/>

                </BodySimpleModalV3>
            }
        </div>

        <BodySimpleModalV3 message={'Future Surgical Appointments'}>
            <Button click={getFutureSurgicalAppointmentsHandler} btnStyle='btn_simple' isLoading={loading} loaderType={'dark'}><i className="ti ti-calendar-plus"></i></Button>
        </BodySimpleModalV3>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={() => setShowModal(false)} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={() => setShowModal(false)} modalTitle={'Select A New Appointment'}>
                        <PannelBody background={"var(--line-transparent)"}>
                            <div className='flex-vertical-center'>
                                {futureSurgicalAppointments && futureSurgicalAppointments.length > 0 ? `Future surgical appointments found: ${futureSurgicalAppointments.length}` : 'No future surgical appointments found'}
                            </div>                            
                        </PannelBody>
                        <PannelBody>
                            {futureSurgicalAppointments && futureSurgicalAppointments.length > 0 && futureSurgicalAppointments.map(appointment => (
                                <FutureAppointmentItem key={appointment.id} appointment={appointment} itemData={itemData} apiCase={apiCase} closeModal={() => setShowModal(false)}/>
                            ))}                   
                            
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
    
}